import { render, staticRenderFns } from "./EnVivo.vue?vue&type=template&id=2935f4e7&scoped=true"
import script from "./EnVivo.vue?vue&type=script&lang=js"
export * from "./EnVivo.vue?vue&type=script&lang=js"
import style0 from "./EnVivo.vue?vue&type=style&index=0&id=2935f4e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2935f4e7",
  null
  
)

export default component.exports